(function () {
  const root = document.querySelector(".canopy-upcoming");
  if (!root) return;

  const key = "canopy-live-bookmarks";
  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(key) || "[]");
    } catch (error) {
      return [];
    }
  };
  const write = (items) => localStorage.setItem(key, JSON.stringify(items));
  const paint = () => {
    const saved = read();
    root.querySelectorAll("[data-show-handle]").forEach((item) => {
      const handle = item.getAttribute("data-show-handle");
      const button = item.querySelector("[data-bookmark]");
      if (!button) return;
      const on = saved.some((entry) => entry.handle === handle);
      button.textContent = on ? "Bookmarked" : "Bookmark";
      button.setAttribute("aria-pressed", on ? "true" : "false");
    });
  };

  root.addEventListener("click", (event) => {
    const button = event.target.closest("[data-bookmark]");
    if (!button) return;
    const item = button.closest("[data-show-handle]");
    const handle = item.getAttribute("data-show-handle");
    const title = item.getAttribute("data-show-title");
    const saved = read();
    const next = saved.some((entry) => entry.handle === handle)
      ? saved.filter((entry) => entry.handle !== handle)
      : saved.concat({ handle, title, savedAt: Date.now() });
    write(next);
    paint();
  });

  paint();
})();
